// deps
import React, { memo } from "react";

// internal-deps
import { ApplyCouponSuggestion } from "@swiggy-private/cart-types";

// components
import CartAddItemsV2 from "./CartAddItemsV2";

export interface CartAddItemsProps {
    onClick: VoidFunction;
    couponSavingsInfo?: ApplyCouponSuggestion;
    onImpressionEvent: (isCouponWidget: boolean) => void;
    autoAddPlan?: string;
    text?: string;
}

function CartAddItems({ ...restProps }: CartAddItemsProps) {
    return <CartAddItemsV2 {...restProps} />;
}

export default memo(CartAddItems);
